<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">URL</div>
            </div>
            <input
                type="url"
                class="form-control"
                required
                pattern="https://.+"
                v-model="url"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">API Key</div>
            </div>
            <input
                type="password"
                class="form-control"
                required
                v-model="apiKey"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Callmaker Order Id</div>
            </div>
            <input
                type="text"
                class="form-control"
                required
                v-model="fieldCallmakerOrderId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Callmaker Donor Id</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCallmakerDonorId"
                @input="onUpdate"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Fältnamn: Callmaker Campaign Id</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="fieldCallmakerCampaignId"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const url = ref(null);
const apiKey = ref(null);
const fieldCallmakerOrderId = ref(null);
const fieldCallmakerDonorId = ref(null);
const fieldCallmakerCampaignId = ref(null);
const serializedValue = computed(() => {
  return {
    url: url.value,
    api_key: apiKey.value,
    field_callmaker_order_id: fieldCallmakerOrderId.value,
    field_callmaker_donor_id: fieldCallmakerDonorId.value,
    field_callmaker_campaign_id: fieldCallmakerCampaignId.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    url.value = modelValue.value.url;
    apiKey.value = modelValue.value.api_key;
    fieldCallmakerOrderId.value = modelValue.value.field_callmaker_order_id;
    fieldCallmakerDonorId.value = modelValue.value.field_callmaker_donor_id;
    fieldCallmakerCampaignId.value = modelValue.value.field_callmaker_campaign_id;
  }
}, {
  immediate: true
});
</script>
